import React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import { client, AuthProvider } from '@app/providers';
import { Routes } from '@app/routes';
import { GlobalStyles } from '@app/components';

function App() {
  return (
    <ApolloProvider client={client}>
      <GlobalStyles />
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </ApolloProvider>
  );
}

export default App;
